export const DELIVERY_PROVIDERS = [
  { id: 'YANDEX', name: 'Яндекс Доставка' },
  { id: 'OZON', name: 'Ozon Доставка' },
];

export const deliveryProviderLabel = (provider) =>
  DELIVERY_PROVIDERS.find((item) => item.id === provider)?.name || 'Доставка';
